import React, { Component } from "react";
import {
  Router,
  RouterProps,
  Styled
} from "../../../toolkit/decorators/Artifact";
import s from "./styles.scss";
import { Container, Row, UncontrolledTooltip } from "reactstrap";
import { errorNotification } from "../../../utils/notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faInfoCircle,
  faShoppingCart,
  faSpinner,
  faUser
} from "@fortawesome/free-solid-svg-icons";
import { TotalPassDetalleDispatcher } from "../../containers/totalpassDetalle/TotalPassDetalle.dispatcher";
import { TotalPassDetalleStore } from "../../containers/totalpassDetalle/TotalPassDetalle.store";
import { BFF_URL, IMAGES_ENDPOINT } from "../../../utils/constants";
import TotalPassDetalleTab from "./TotalPassDetalle.tabs";
import TotalPassDetalleInfo from "./TotalPassDetalle.info";
import permissionCodes from "../../../utils/permissionCodes";
import { userHasPermission } from "../../../utils/accessTree";

const { MENU_CARRITO } = permissionCodes;

interface Props
  extends TotalPassDetalleDispatcher,
    TotalPassDetalleStore,
    RouterProps<any> {}

interface State {}

@Router()
@Styled(s)
export default class TotalPassDetalleComponent extends Component<Props, State> {
  async componentDidMount(): Promise<void> {
    this.props.clearTotalPass();
    const { idPersona } = this.props.match.params;
    const preview = await this.props.getTotalPass(idPersona);

    if (!preview.fulfilled) {
      errorNotification("Error al cargar los datos del cliente");
    }
  }

  render() {
    if (!this.props.totalPass) {
      return (
        <Container>
          <FontAwesomeIcon icon={faSpinner} pulse />
        </Container>
      );
    }

    const totalPass = this.props.totalPass;
    const hasPhoto = Number(totalPass.fotoStorageId) > 0;
    const accessTooltipId = `totalpass-acceso-${totalPass.idPersona}`;
    const eyeTooltipId = `persona-ver-${totalPass.idPersona}`;
    const cartTooltipId = `persona-carrito-${totalPass.idPersona}`;

    return (
      <Container>
        <div className={s.info}>
          {/* Fotografía de la persona */}
          <div
            className={`${s.foto} ${
              hasPhoto ? s.fotoConImagen : s.fotoSinImagen
            }`}
          >
            {hasPhoto ? (
              <img
                src={`${BFF_URL}${IMAGES_ENDPOINT}/${totalPass.fotoStorageId}`}
                alt={`Fotografía de ${totalPass.nombreCompleto || "persona"}`}
              />
            ) : (
              <FontAwesomeIcon icon={faUser} />
            )}
          </div>

          {/* Header con datos a la derecha de la foto */}
          <div
            className={`${s.persona} ${
              hasPhoto ? s.personaConImagen : s.personaSinImagen
            }`}
          >
            <div className={s.heading}>
              {/* Nombre completo (grande) */}
              <h3>{totalPass.nombreCompleto}</h3>

              {/* Acciones (íconos) a la derecha del nombre */}
              <div className={s.actions}>
                <>
                  <span className={s.actionLink} id={accessTooltipId}>
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      color={totalPass.tieneAcceso ? "#008080" : "#600"}
                    />
                  </span>
                  <UncontrolledTooltip
                    placement="bottom"
                    target={accessTooltipId}
                  >
                    {totalPass.tieneAcceso
                      ? "El cliente tiene acceso"
                      : (totalPass.razonesSinAcceso || []).length
                      ? totalPass.razonesSinAcceso.map((razon, index) => (
                          <div key={index}>{razon}</div>
                        ))
                      : "No cuenta con acceso al club"}
                  </UncontrolledTooltip>
                </>

                <>
                  <a
                    className={s.actionLink}
                    href={`/externo/${totalPass.idPersona}/detalle`}
                    target="_blank"
                    id={eyeTooltipId}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </a>
                  <UncontrolledTooltip placement="bottom" target={eyeTooltipId}>
                    Ver persona
                  </UncontrolledTooltip>
                </>

                {userHasPermission(MENU_CARRITO) && (
                  <>
                    <a
                      className={s.actionLink}
                      href={`/productos/carrito/${totalPass.idPersona}`}
                      target="_blank"
                      id={cartTooltipId}
                    >
                      <FontAwesomeIcon icon={faShoppingCart} />
                    </a>
                    <UncontrolledTooltip
                      placement="bottom"
                      target={cartTooltipId}
                    >
                      Ver carrito
                    </UncontrolledTooltip>
                  </>
                )}
              </div>
            </div>

            {/* División de nombre y parte inferior */}
            <hr />

            {/* Identificador de la persona, al lado de la foto */}
            <p>ID Persona: {totalPass.idPersona}</p>
          </div>
        </div>

        {/* Cards informativos */}
        <TotalPassDetalleInfo detalle={totalPass} />

        {/* Tabs */}
        <TotalPassDetalleTab {...this.props} detalle={totalPass} />
      </Container>
    );
  }
}
